<template>
  <CommentModeration type="post"/>
</template>

<script>
import CommentModeration from "@/views/includes/CommentModeration.vue";

export default { name: 'CommentsList', components: { CommentModeration } }
</script>
